import { Box, ListItem, OrderedList, UnorderedList } from '@chakra-ui/react'
import React from 'react'
import { withGuestLayout } from 'src/components/Layout'
import styles from './style.module.scss'

const TermsPage = () => {
  return (
    <Box className={styles.page}>
      <Box className={styles.mainBox}>
        <Box className={styles.headingArea}>
          <h1 className={styles.h1}>Jammy利用規約</h1>
        </Box>
        <ol className={styles.termList}>
          <p className={styles.termsListItemText}>
            本規約は、株式会社MOLE（以下「当社」という。）が提供する「インターネット宿泊予約システム『Jammy』」（以下「本システム」という。）の円滑な運用を目的として定めるものです。
          </p>
          <li className={styles.termsListItem}>
            <h2 className={styles.termsListItemHeading}>第1条 本システム</h2>
            <p className={styles.termsListItemText}>
              当社は本規約に定める条件にて本システムの提供を行ない、お客様は本規約に定める条件にてこれを利用するものとします。
              <br />
              本規約に定める条件と個別契約に定める条件が異なるときは、個別契約に定める条件が本規約に優先して適用されるものとします。
            </p>
          </li>
          <li className={styles.termsListItem}>
            <h2 className={styles.termsListItemHeading}>第2条 定義</h2>
            <p className={styles.termsListItemText}>
              本規約において、用語の定義は以下のとおりとします。
            </p>
            <p className={styles.termsListItemText}>
              <b>本システム</b>
            </p>
            <p className={styles.termsListItemText}>
              本規約に基づき当社がお客様に提供する、ウェブブラウザを介し、インターネット上での宿泊者からの宿泊予約の申込の受付並びに予約の受付状況の閲覧を可能とするシステム
            </p>
            <p className={styles.termsListItemText}>
              <b>お客様</b>
            </p>
            <p className={styles.termsListItemText}>
              本規約をご承諾の上、当社所定の手続に従い本システムのご利用を申込んだ個人事業主又は法人
            </p>
            <p className={styles.termsListItemText}>
              <b>宿泊者</b>
            </p>
            <p className={styles.termsListItemText}>
              本システムにより、オンラインでお客様に宿泊予約の申込等を行なう個人又は団体
            </p>
            <p className={styles.termsListItemText}>
              <b>ウェブブラウザ</b>
            </p>
            <p className={styles.termsListItemText}>
              インターネットに接続されたコンピュータとの間で情報を送受信し、ウェブページを閲覧する機能を備えたソフトウェア
            </p>
            <p className={styles.termsListItemText}>
              <b>ID</b>
            </p>
            <p className={styles.termsListItemText}>
              お客様を識別するために当社が付与する英数字、記号を組み合わせた符号
            </p>
            <p className={styles.termsListItemText}>
              <b>パスワード</b>
            </p>
            <p className={styles.termsListItemText}>
              IDと組み合わせて、お客様を識別するために当社が付与する英数字を組み合わせた符号
            </p>
            <p className={styles.termsListItemText}>
              <b>お客様設備</b>
            </p>
            <p className={styles.termsListItemText}>
              本システムを利用するため、お客様が設置するコンピュータ、電気通信設備その他の機器及びソフトウェア
            </p>
            <p className={styles.termsListItemText}>
              <b>本システム提供設備</b>
            </p>
            <p className={styles.termsListItemText}>
              本システムを提供するため、当社が用意するコンピュータ、電気通信設備その他の機器及びソフトウェア
            </p>
            <p className={styles.termsListItemText}>
              <b>ISP（インターネット・サービス・プロバイダ）</b>
            </p>
            <p className={styles.termsListItemText}>
              電話回線やデータ通信専用回線（光ファイバー等）を通じて、コンピュータをインターネットに接続させる業者
            </p>
          </li>
          <li className={styles.termsListItem}>
            <h2 className={styles.termsListItemHeading}>
              第3条 利用契約のお申込み
            </h2>
            <UnorderedList className={styles.list}>
              <ListItem>
                お客様は、本規約をご承諾いただいた上で、本システムの利用申込書に当社の指定する事項を記入し、これを郵送又はPDFデータにて当社に提出するものとします。
              </ListItem>
              <ListItem>
                前項の利用申込書に入力した情報（以下「申込情報」という。）が、当社に到達した時に申込が完了したとみなします。
              </ListItem>
            </UnorderedList>
          </li>
          <li className={styles.termsListItem}>
            <h2 className={styles.termsListItemHeading}>
              第4条 契約の基本事項
            </h2>
            <OrderedList className={styles.list}>
              <ListItem>
                本契約は、以下の各号に掲げるすべての事由を要件として成立するものとします。
              </ListItem>
              <UnorderedList>
                <ListItem listStyleType="circle">
                  前条の第2項において定める申込情報が当社に到達すること
                </ListItem>
                <ListItem listStyleType="circle">
                  当社がお客様に対して承諾の通知を発信すること
                </ListItem>
              </UnorderedList>
              <ListItem>
                本契約は、当社がお客様に対して承諾の通知を電子メール、ファクシミリ又は郵便にて発信した時に成立するものとします。
              </ListItem>
              <ListItem>
                当社は、他の定めにかかわらず、申込者が次の各号のいずれかに該当する場合、本契約の成立を取り消すことができます。
              </ListItem>
              <UnorderedList>
                <ListItem listStyleType="circle">
                  申込書に虚偽の記載、誤記、又は記入漏れがあることが判明した場合
                </ListItem>
                <ListItem listStyleType="circle">
                  お支払いの履行が困難であると判断した場合
                </ListItem>
                <ListItem listStyleType="circle">
                  その他、当社が本契約の成立を不適当と判断した場合
                </ListItem>
              </UnorderedList>
            </OrderedList>
          </li>
          <li className={styles.termsListItem}>
            <h2 className={styles.termsListItemHeading}>
              第5条 契約期間・更新
            </h2>
            <UnorderedList className={styles.list}>
              <ListItem>
                利用契約の契約期間は、契約成立日の属する月の翌月1日から満1年間とします。
              </ListItem>
              <ListItem>
                利用契約の契約期間満了の日から1か月前までに、当社及びお客様のいずれからも何らの申出もないときは、自動的に有効期間満了の日の翌日から1年間延長されるものとし、それ以降も同様とします。
              </ListItem>
            </UnorderedList>
          </li>
          <li className={styles.termsListItem}>
            <h2 className={styles.termsListItemHeading}>
              第6条 通知及び同意の方法
            </h2>
            <OrderedList className={styles.list}>
              <ListItem>
                当社からお客様への本システムの運営及び内容に関する通知は、申込情報に記載された連絡先に対する電子メール、ファクシミリ、郵便又はその他当社が適当と認める方法により行なうものとします。
              </ListItem>
              <ListItem>
                前項の通知の内容を反映した本システムをお客様が利用したことにより、同通知の内容をお客様が承諾したものとみなします。
              </ListItem>
            </OrderedList>
          </li>
          <li className={styles.termsListItem}>
            <h2 className={styles.termsListItemHeading}>第7条 変更の届出</h2>
            <OrderedList className={styles.list}>
              <ListItem>
                お客様は、申込情報に変更があった場合には、そのことを速やかに当社に届け出るものとします。
              </ListItem>
              <ListItem>
                お客様から申込情報の変更に関する届出があった場合には、それ以後、当社からお客様に対する連絡、通知等は、変更先に対して行なわれるものとします。
              </ListItem>
              <ListItem>
                当社は、お客様より本条第1項の届出がなく、当社からの通知又は送付書類が変更前の連絡先に到達又は不到達となったことに起因して、お客様及び第三者に対して生じた如何なる損害についても一切の責任を負わないものとします。
              </ListItem>
            </OrderedList>
          </li>
          <li className={styles.termsListItem}>
            <h2 className={styles.termsListItemHeading}>第8条 権利義務譲渡</h2>
            <OrderedList className={styles.list}>
              <ListItem>
                お客様は、本規約に定める権利義務を第三者に譲渡又は担保に提供することができないものとします。
              </ListItem>
              <ListItem>
                当社は、本規約に定める権利義務を第三者に譲渡又は担保に提供することがあり、お客様はこれをあらかじめ承諾します
              </ListItem>
            </OrderedList>
          </li>
          <li className={styles.termsListItem}>
            <h2 className={styles.termsListItemHeading}>
              第9条 本システムの利用開始
            </h2>
            <OrderedList className={styles.list}>
              <ListItem>
                本システムは、本契約の成立後、当社からお客様に対して通知するサービス開通案内を発信した時から利用可能となります。
              </ListItem>
              <ListItem>
                当社は、本契約が成立したお客様に対して、本システムをご利用の際に必要となる管理用のIDとパスワードを、当社の定める方法で通知します。
              </ListItem>
            </OrderedList>
          </li>
          <li className={styles.termsListItem}>
            <h2 className={styles.termsListItemHeading}>
              第10条 本システムの利用期間
            </h2>
            <p className={styles.termsListItemText}>
              本システムの利用期間は、前条1項に定めるサービス開通案内を発信した日から、契約期間満了の日までとします。
            </p>
          </li>
          <li className={styles.termsListItem}>
            <h2 className={styles.termsListItemHeading}>第11条　利用料金</h2>
            <OrderedList className={styles.list}>
              <ListItem>
                お客様は、別途定める本システムの利用料金を、当社又はその代理店が指定する方法にて支払うものとします。
              </ListItem>
              <ListItem>
                前項の利用料金は、第9条第1項に定めるサービス開通案内を発信した日を起算日として適用されます。
              </ListItem>
              <ListItem>
                当社は、本システムの利用料金の一部または全部に変更を加えることができ、お客様はあらかじめこれを承諾するものとします。
              </ListItem>
              <ListItem>
                当社又はその代理店は、お客様から本システムの利用料金その他の債務について支払期日を経過してもなお、お支払いがない場合には、お客様に対して、支払期日の翌日から支払日まで、年14.6%パーセントの利息を付して請求することができるものとします。
              </ListItem>
            </OrderedList>
          </li>
          <li className={styles.termsListItem}>
            <h2 className={styles.termsListItemHeading}>
              第12条 ID・パスワード等の自己管理
            </h2>
            <OrderedList className={styles.list}>
              <ListItem>
                当社がお客様に対して発行したID及びパスワードについては、お客様の責任において適切に管理するものとします。お客様は、ID及びパスワードを第三者に開示してはなりません。
              </ListItem>
              <ListItem>
                当社は、第三者が何らかの手段でお客様のID及びパスワードを入手して、これを不正に使用したためにお客様又は第三者に生じた損害について、一切の責任を負わないものとします。
              </ListItem>
            </OrderedList>
          </li>
          <li className={styles.termsListItem}>
            <h2 className={styles.termsListItemHeading}>
              第13条 本システム利用のための設備設定・維持
            </h2>
            <OrderedList className={styles.list}>
              <ListItem>
                お客様は、自己の責任と費用をもって、お客様設備を設定し、お客様設備及び本システム利用のための環境を維持するものとします。
              </ListItem>
              <ListItem>
                お客様は、本システムを利用するにあたり、自己の責任と費用をもって、ISPを利用してお客様設備をインターネットに接続するものとします。
              </ListItem>
              <ListItem>
                お客様設備、前項に定めるインターネット接続並びに本システム利用のための環境に不具合がある場合には、当社はお客様に対して本システム提供の義務を負わないものとします。
              </ListItem>
              <ListItem>
                当社は、当社が本システムに関して保守、運用上又は技術上必要であると判断した場合には、お客様が本システムの利用に際して提供、伝送するデータ等について、監視、分析、調査等必要な行為を行なうことができるものとします。
              </ListItem>
              <ListItem>
                お客様は、自身の使用環境に応じ、コンピュータ・ウイルスの感染、不正アクセス及び情報漏洩の防止等のセキュリティを保持するものとします。
              </ListItem>
            </OrderedList>
          </li>
          <li className={styles.termsListItem}>
            <h2 className={styles.termsListItemHeading}>第14条 禁止事項</h2>
            <OrderedList className={styles.list}>
              <ListItem>
                お客様は、当社が提供する本システムの利用に際して、以下の各号に掲げる行為を行なわないものとします。
              </ListItem>
              <UnorderedList>
                <ListItem listStyleType="circle">
                  本システム提供設備に過大な負荷を与える等の不正アクセス行為
                </ListItem>
                <ListItem listStyleType="circle">
                  本規約に基づき当社から提供されたものを第三者に貸与、譲渡、担保設定又は使用させる行為
                </ListItem>
                <ListItem listStyleType="circle">
                  本規約に基づき当社から提供されたものを複製、改変、編集又は頒布する行為
                </ListItem>
                <ListItem listStyleType="circle">
                  本規約に基づき当社から提供されたものを悪用する行為又は目的外での利用する行為
                </ListItem>
                <ListItem listStyleType="circle">
                  わいせつ又は青少年に有害な目的での利用方法
                </ListItem>
                <ListItem listStyleType="circle">
                  お客様のアカウントを第三者に貸与又は利用させる行為
                </ListItem>
                <ListItem listStyleType="circle">
                  当社又は第三者の著作権、商標等の知的財産権を侵害し又は侵害するおそれのある行為
                </ListItem>
                <ListItem listStyleType="circle">
                  当社又は第三者を誹謗中傷し若しくは信用名誉を毀損する行為又はプライバシーを侵害する行為
                </ListItem>
                <ListItem listStyleType="circle">
                  当社又は第三者の財産を侵害し又は事業営業活動を妨害する行為
                </ListItem>
                <ListItem listStyleType="circle">
                  法令に違反し又は公序良俗に反する行為
                </ListItem>
                <ListItem listStyleType="circle">
                  その他当社が不適切であると判断する行為
                </ListItem>
              </UnorderedList>
              <ListItem>
                お客様は、前項各号のいずれかに該当する行為がなされたことを知った場合又は該当する行為がなされるおそれがあると判断した場合は、直ちに当社に通知するものとします。
              </ListItem>
            </OrderedList>
          </li>
          <li className={styles.termsListItem}>
            <h2 className={styles.termsListItemHeading}>
              第15条 秘密情報の取扱い
            </h2>
            <OrderedList className={styles.list}>
              <ListItem>
                当社は、お客様より、本システムの利用にあたって提供を受けた技術上又は営業上その他業務上の情報のうち、お客様が特に秘密である旨あらかじめ書面で指定した情報で、提供の際に秘密情報の範囲を特定し、秘密情報である旨の表示を明記した情報（以下「秘密情報」といいます。）を第三者に、開示又は漏洩しないものとします。但し、お客様より予め承諾を受けた場合及び次の各号のいずれかに該当する情報については、この限りではありません。
              </ListItem>
              <UnorderedList>
                <ListItem listStyleType="circle">
                  お客様より開示を受けた際、すでに当社が自ら保有又は正当な権限を有する第三者から合法的に入手していた情報
                </ListItem>
                <ListItem listStyleType="circle">
                  お客様より開示を受けた際、すでに公知であった情報
                </ListItem>
                <ListItem listStyleType="circle">
                  お客様より開示を受けた後、当社の責によらず公知となった情報
                </ListItem>
                <ListItem listStyleType="circle">
                  お客様より開示を受けた後、当社が独自に開発した情報
                </ListItem>
                <ListItem listStyleType="circle">
                  本条に従った指定、範囲の特定や秘密情報である旨の表示がなされず提供された情報
                </ListItem>
              </UnorderedList>
              <ListItem>
                前項の定めにかかわらず、当社は、秘密情報のうち法令の定めに基づき又は権限のある官公署からの要求により開示すべき情報を、当該法令の定めに基づく開示先又は当該官公署に対し、開示することができるものとします。この場合、当社は、関係法令に反しない限り、当該開示前に開示する旨をお客様に通知するものとし、開示前に通知を行なうことができない場合は、開示後にすみやかにこれを行なうものとします。
              </ListItem>
              <ListItem>
                当社は、秘密情報の取扱いについて、管理に必要な措置を講ずるものとします。
              </ListItem>
              <ListItem>
                当社は、お客様より提供を受けた秘密情報は、本システムの遂行目的の範囲内でのみ使用します。
              </ListItem>
              <ListItem>
                各前項の規定にかかわらず、当社が必要と認めた場合には、第17条所定の業務委託先に対して、委託のために必要な範囲で、お客様からの事前の承諾を受けることなく、秘密情報を開示することができるものとします。但し、この場合、当社は業務委託先に対して、本条に基づき当社が負う秘密保持義務と同等のものを負わせるものとします。
              </ListItem>
            </OrderedList>
          </li>
          <li className={styles.termsListItem}>
            <h2 className={styles.termsListItemHeading}>
              第16条　お客様情報・宿泊者情報の取扱い
            </h2>
            <OrderedList className={styles.list}>
              <ListItem>
                当社は、本システムの利用にあたってお客様より提供を受けた営業上その他業務上の情報に含まれる個人情報並びに宿泊者より提供を受けた個人情報を、本システム遂行目的の範囲内のみで使用し、第三者に開示又は漏洩しないものとします。
              </ListItem>
              <ListItem>
                前項の個人情報の取扱いについては、前条の第2項ないし第5項の規定を準用するものとします。この場合において、「お客様」とあるのは「お客様又は宿泊者」と読み替えるものとします。
              </ListItem>
              <ListItem>
                お客様は、当社に宿泊者の個人情報を提供する場合、自らの宿泊者から宿泊者情報を取得するにあたり、その利用目的の通知や当社との共有等、個人情報保護法その他の法令に従って適切な措置を講じるものとし、本サービスの利用にあたって適法に顧客情報を利用するためのあらゆる措置を講じます
              </ListItem>
              <ListItem>
                当社は本サービスの提供や機能改善等の目的のために、特定の個人を識別できないようにデータを加工した上で顧客情報を利用する場合があります。
              </ListItem>
            </OrderedList>
          </li>
          <li className={styles.termsListItem}>
            <h2 className={styles.termsListItemHeading}>第17条 業務委託</h2>
            <p className={styles.termsListItemText}>
              当社は、本システムの提供に関する業務の全部又は一部を、お客様の承諾なしに第三者に委託できるものとします。その場合には、当社は責任をもって委託先を管理するものとします。
            </p>
          </li>
          <li className={styles.termsListItem}>
            <h2 className={styles.termsListItemHeading}>
              第18条 情報等の保管及び消去
            </h2>
            <OrderedList className={styles.list}>
              <ListItem>
                当社は、お客様が本システムを利用して登録した情報について、本システム提供設備等の故障等により滅失した場合に復元する目的で、これを別に記録して一定期間保管することがありますが、その義務を負うものではありません。
              </ListItem>
              <ListItem>
                当社は、お客様が本システムを利用することによって生ずる通信記録を、一定期間保管することがありますが、その義務を負うものではありません。また、当社は当該情報の開示請求を受けるものではありません。
              </ListItem>
              <ListItem>
                当社は、お客様が本システムを利用して登録した情報のうち、登録時の目的を達成し、当社において本システムの提供に不要と判断したものについては、お客様に通知を要しないで、これを消去できるものとします。
              </ListItem>
              <ListItem>
                当社は、お客様が本システムを利用して登録した情報について、本契約が解除された場合には、解除の日の翌日以降にすべての情報を消去できるものとします。
              </ListItem>
              <ListItem>
                当社は、本条第3項及び第4項による登録情報の消去によりお客様及び第三者に生じた損害について一切の責任を負わないものとします
              </ListItem>
            </OrderedList>
          </li>
          <li className={styles.termsListItem}>
            <h2 className={styles.termsListItemHeading}>第19条 設備の障害等</h2>
            <OrderedList className={styles.list}>
              <ListItem>
                当社は、本システム提供設備について障害があることを知ったときは、直ちにお客様にその旨を通知するものとします。
              </ListItem>
              <ListItem>
                当社は、本システム提供設備について障害があることを知ったときは、直ちに本システム提供設備を修理又は復旧します。
              </ListItem>
              <ListItem>
                当社は、本システム提供設備に接続する当社が借り受けた電気通信回線について障害があることを知ったときは、当該電気通信回線を提供するISP等に修理又は復旧を指示するものとします。
              </ListItem>
              <ListItem>
                上記のほか、本システムに不具合が発生した場合には、お客様及び当社はそれぞれ直ちに相手方に通知し、両者協議の上、各自の行なうべき対応措置を決定してそれを実施するものとします。
              </ListItem>
            </OrderedList>
          </li>
          <li className={styles.termsListItem}>
            <h2 className={styles.termsListItemHeading}>
              第20条 システムの中止
            </h2>
            <OrderedList className={styles.list}>
              <ListItem>
                当社は、以下の各号のいずれかに該当する場合には、本システムの提供を中止することがあります。
              </ListItem>
              <UnorderedList>
                <ListItem listStyleType="circle">
                  当社が、定期的若しくは緊急にシステム保守を行なう場合
                </ListItem>
                <ListItem listStyleType="circle">
                  当社の本システム提供用設備若しくは当社の利用するISPその他電気通信事業者の設備などの保守又は工事の作業上やむを得ない場合
                </ListItem>
                <ListItem listStyleType="circle">
                  天災、事変、その他緊急非常事態が発生し若しくは発生するおそれがあり、復旧作業又は予防対策上やむを得ない場合
                </ListItem>
                <ListItem listStyleType="circle">
                  本システムに対して許容範囲を著しく超える負荷がかかる又はその恐れがある場合
                </ListItem>
                <ListItem listStyleType="circle">
                  当社が本システムの運用の全部又は一部を中止することが望ましいと判断した場合
                </ListItem>
              </UnorderedList>
              <ListItem>
                当社は、前項において定める本システムの中止を行なう場合には、お客様に事前に通知いたします。但し、緊急を要する場合には、お客様への事前通知を省略することがあります。
              </ListItem>
              <ListItem>
                当社は、本条第1項において定める本システムの提供の中止によりお客様に生じた損害について一切の責任を負わないものとします。
              </ListItem>
            </OrderedList>
          </li>
          <li className={styles.termsListItem}>
            <h2 className={styles.termsListItemHeading}>
              第21条　システムの停止
            </h2>
            <OrderedList className={styles.list}>
              <ListItem>
                当社は、お客様について前条第1項各号に掲げるいずれかの事由がある場合には、お客様に対する本システムの提供を直ちに停止する場合があります。
              </ListItem>
              <ListItem>
                お客様は、前項において定めるところにより本システムの提供が停止された間についても、すでに当社にお支払いになった所定の料金等の返金を受けることはできないものとします。
              </ListItem>
              <ListItem>
                当社は、本条第1項において定める本システムの提供の停止によりお客様及び第三者に生じた損害について一切の責任を負わないものとします。
              </ListItem>
            </OrderedList>
          </li>
          <li className={styles.termsListItem}>
            <h2 className={styles.termsListItemHeading}>
              第22条 システムの変更及び一部廃止
            </h2>
            <OrderedList className={styles.list}>
              <ListItem>
                当社は、業務上その必要があると客観的に判断したときは、提供しているソフトウェアの改廃を含め、お客様に対して現に提供している本システムの内容を変更又は一部の廃止をすることがあります。
              </ListItem>
              <ListItem>
                当社は、前項において定める本システムの内容の変更又は一部廃止をする場合には、事前にその内容をお客様に通知いたします。
              </ListItem>
              <ListItem>
                当社は、本条第1項において定める本システムの内容の変更又は一部廃止によりお客様及び第三者に生じた損害について一切の責任を負わないものとします。
              </ListItem>
            </OrderedList>
          </li>
          <li className={styles.termsListItem}>
            <h2 className={styles.termsListItemHeading}>
              第23条 システムの廃止
            </h2>
            <OrderedList className={styles.list}>
              <ListItem>
                当社は、業務上その必要があると客観的に判断したときは、提供しているソフトウェアの廃止を含め、お客様に対して現に提供している本システムの全部を廃止することがあります。
              </ListItem>
              <ListItem>
                当社は、前項において定める本システムの廃止を行なう場合には、事前にその内容をお客様に通知いたします。
              </ListItem>
              <ListItem>
                当社は、本条第１項において定める本システムの廃止によりお客様及び第三者に生じた損害について一切の責任を負わないものとします。
              </ListItem>
            </OrderedList>
          </li>
          <li className={styles.termsListItem}>
            <h2 className={styles.termsListItemHeading}>第24条 当社の責任</h2>
            <OrderedList className={styles.list}>
              <ListItem>
                当社は、当社の推奨環境において機能するよう本システムを提供するものとします。なお、本システム利用の結果、必ずしもお客様の目的に適合した完全、正確、確実又は有用な結果ではない場合も起こりえます。その際、本システムがお客様の事業に役立つよう、当社はお客様と誠心誠意、次善策を検討することとします。
              </ListItem>
              <ListItem>
                本システムの利用に際して、お客様は、登録した情報の一部でも破損しないよう、取り扱いには十分に注意するものとします。もし、本システムの欠陥のためにこのような事態が起こった場合には、当社は、その復旧に努めることとします。
              </ListItem>
            </OrderedList>
          </li>
          <li className={styles.termsListItem}>
            <h2 className={styles.termsListItemHeading}>第25条 免責</h2>
            <OrderedList className={styles.list}>
              <ListItem>
                当社は、本システムの利用に際してお客様又は第三者に損害が生じた場合、当社又は当社の業務委託先において故意又は重過失がある場合は、責任を持って対処するものとしますが、その他の場合は責任を負わないものとします。
              </ListItem>
              <ListItem>
                本システムの利用に際して、お客様が、故意又は重過失により当社又は第三者に対して損害を与えた場合には、お客様は損害の賠償をするものとします。
              </ListItem>
              <ListItem>
                本システムの利用に際して、お客様と第三者との間で紛争が生じた場合、お客様は、自己の費用負担と責任において当該紛争を解決するものとし、当社は可能な範囲で資料の提供等をすることとします。
              </ListItem>
            </OrderedList>
          </li>
          <li className={styles.termsListItem}>
            <h2 className={styles.termsListItemHeading}>第26条 損害賠償責任</h2>
            <p className={styles.termsListItemText}>
              当社は、本システムに関連してお客様又は第三者に損害を与えた場合で、前条第1項により責任を負う場合においては、現実に発生した直接の損害の範囲において1年分（契約期間が1年を下回る場合にはその期間）の利用料金を上限として賠償責任を負うものとします。
            </p>
          </li>
          <li className={styles.termsListItem}>
            <h2 className={styles.termsListItemHeading}>第27条権利帰属</h2>
            <p className={styles.termsListItemText}>
              本システムの提供に際して、当社がお客様に提供するソフトウェア等のプログラムその他の著作物に関する著作権その他一切の知的財産権は、当社又は正当な権利を有する第三者に独占的に帰属し、お客様は、当該権利者の許諾する範囲でこれを使用することができるものとし、お客様に譲渡又は本規約その他個別の契約に定める以上に使用を許諾するものではありません。
            </p>
          </li>
          <li className={styles.termsListItem}>
            <h2 className={styles.termsListItemHeading}>第28条 情報等の通知</h2>
            <OrderedList className={styles.list}>
              <ListItem>
                当社は、本システムの利用上必要と判断される、本システムの中止、停止、変更及び一部廃止、廃止に関すること、提供するソフトウェア製品に関することその他の情報等について、本システムのウェブページへの掲載、電子メールの送信、書面の郵送（メール便を含む）、ファクシミリの送信のいずれかの方法により、お客様に通知するものとします。但し、緊急を要する場合には、当社が適当と認める方法により通知を行なうものとします。
              </ListItem>
              <ListItem>
                ウェブページへの掲載による通知の場合には、掲載された時をもって通知が完了したものとみなします。
              </ListItem>
              <ListItem>
                電子メールの送信による通知の場合には、当社に届け出たお客様のメールアドレス宛に発信した時をもって通知が完了したものとみなします。
              </ListItem>
              <ListItem>
                書面の郵送による通知の場合には、当社に届け出たお客様の住所宛に書面を発信した時をもって通知が完了したものとみなします
              </ListItem>
              <ListItem>
                ファクシミリの送信による通知の場合には、当社に届け出たお客様のファクシミリ番号宛に発信した時をもって通知が完了したものとみなします。
              </ListItem>
              <ListItem>
                当社は、本条第１項に定める方法により、当社からお客様に対しての通知が到達又は不到達となったことに起因して、お客様又は第三者に対して生じたいかなる損害についても一切の責任を負わないものとします。
              </ListItem>
            </OrderedList>
          </li>
          <li className={styles.termsListItem}>
            <h2 className={styles.termsListItemHeading}>第29条 本契約の解除</h2>
            <OrderedList className={styles.list}>
              <ListItem>
                お客様は、本契約を解除する場合には、当社が指定する方法で本契約解除の通知を当社に対して行なうものとし、当社が当該通知を受領した日の属する月の末日をもって、解除の効力が発するものとします。但し、お客様は、当社の請求に従い、解約手数料として、本契約解除時から契約期間の満了までにかかる本システムの利用料金の合計額に相当する金額を、当社に支払うものとします。
              </ListItem>
              <ListItem>
                当社は、お客様が以下の各号のいずれかに該当するに至ったときは、何らの通知、催告を要せずに即時に本契約を解除できるものとします。
              </ListItem>
              <UnorderedList>
                <ListItem listStyleType="circle">
                  本規約で定める義務に違反したとき
                </ListItem>
                <ListItem listStyleType="circle">
                  自己振出の手形又は小切手が不渡となり支払停止事由が発生したとき
                </ListItem>
                <ListItem listStyleType="circle">
                  第三者より、競売、差押、仮差押、仮処分、滞納処分、破産手続開始、民事再生手続開始若しくは会社更生手続開始の申立を受け又は破産手続開始、民事再生手続開始若しくは会社更生手続開始の申立をなしたとき
                </ListItem>
                <ListItem listStyleType="circle">
                  解散の手続をしたとき又は監督官庁から営業の取消・停止の処分を受けたとき
                </ListItem>
              </UnorderedList>
            </OrderedList>
          </li>
          <li className={styles.termsListItem}>
            <h2 className={styles.termsListItemHeading}>
              第30条 利用契約規約の改定
            </h2>
            <OrderedList className={styles.list}>
              <ListItem>
                当社は、お客様の許諾を得ずに本規約を変更することがあります。本規約の変更につき、当社は、当社のウェブサイトによる掲示、電子メールによる通知の送付、または類似の手段により、お客様に通知します。お客様は、当社による一切の通知及びその他の連絡を確実にするため、その連絡先を常に最新かつ正確なものに保つ義務を負います。以上にかかわらず、当社は、以下の目的で、本規約をいつでも即時に変更または修正することができます。この場合、当社は、変更内容を上記の方法でお客様に通知します。
              </ListItem>
              <UnorderedList>
                <ListItem listStyleType="circle">
                  法令の遵守、セキュリティの維持・強化、不正行為の防止等
                </ListItem>
                <ListItem listStyleType="circle">
                  サービスの変更又は新たな機能の追加
                </ListItem>
                <ListItem listStyleType="circle">
                  当社が不適切とみなす販売または活動の禁止
                </ListItem>
              </UnorderedList>
              <ListItem>
                改定内容を通知した後14日を経過してもお客様から本契約を解除する旨の申し出がなかった場合には、同日をもって、お客様が改定内容を承諾したものとみなします。
              </ListItem>
            </OrderedList>
          </li>
          <li className={styles.termsListItem}>
            <h2 className={styles.termsListItemHeading}>第31条 表明</h2>
            <p className={styles.termsListItemText}>
              当社及びお客様は、自己が現在次の各号のいずれにも該当しないことを表明し、かつ将来にわたり該当しないことを確約します。
            </p>
            <UnorderedList className={styles.list}>
              <ListItem listStyleType="circle">
                反社会的勢力（暴力団、暴力団員、暴力団準構成員、暴力団関係企業、総会屋等、社会運動標榜ゴロ、政治活動標榜ゴロ、特殊知能暴力集団、反社会的勢力共生者、またはその他これらに準ずる者をいう。以下同じ。）であること。
              </ListItem>
              <ListItem listStyleType="circle">
                反社会的勢力に対して資金等を提供し、または便宜を供与するなどの協力・関与をしていること。
              </ListItem>
              <ListItem listStyleType="circle">
                反社会的勢力を利用していること。
              </ListItem>
              <ListItem listStyleType="circle">
                役員または実質的に経営に関与する者が、反社会的勢力であること、または反社会的勢力と交際していること。
              </ListItem>
              <ListItem listStyleType="circle">
                親会社、子会社、若しくは本契約にかかる下請または再委託先（下請または再委託契約が数次にわたるときには、その全てを含む。）が、前各号の一に該当すること。
              </ListItem>
            </UnorderedList>
          </li>
          <li className={styles.termsListItem}>
            <h2 className={styles.termsListItemHeading}>第32条 疑義</h2>
            <p className={styles.termsListItemText}>
              本規約に定めのない事項又は本規約の条項の解釈等についての疑義が生じた場合は、お客様と当社との間で互いに誠意をもって協議してこれを解決するものとします。
            </p>
          </li>
          <li className={styles.termsListItem}>
            <h2 className={styles.termsListItemHeading}>第33条（準拠法）</h2>
            <p className={styles.termsListItemText}>
              本契約の成立、効力、履行及び解釈に関しては、日本国法が適用されるものとします。
            </p>
          </li>
          <li className={styles.termsListItem}>
            <h2 className={styles.termsListItemHeading}>第34条 管轄裁判所</h2>
            <p className={styles.termsListItemText}>
              本契約に関する訴訟については、当社の普通裁判籍所在地の裁判所を専属的な第一審の管轄裁判所とします。
            </p>
          </li>
        </ol>
      </Box>
    </Box>
  )
}

export default withGuestLayout(TermsPage)
